import React from "react";

const ArticlesOfAssociation = () => {
  return <div>ArticleOfAssociation</div>;
};

export default ArticlesOfAssociation;
